import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import { pagingDefaultSettings } from '../../shared/directives/sortable-table-header.directive';
import { NbDialogService } from '@nebular/theme';
import { ChannelMappingEditComponent } from './channel-mapping-edit.component';
import { ModalConfirmComponent } from '../../shared/components/modals/confirm/modal-confirm.component';
import { FormGroup, Validators, AbstractControl, FormBuilder } from '@angular/forms';
import { ChannelMappingService } from '../../shared/services/channel-mapping.service';
import { UserService, UserRolesService, CompaniesService, LoadingOverlayService, ChannelMappingStorageService } from '../../shared/services';
import { isEmpty, orderBy, forEach, compact } from 'lodash';
import { CPATTERN } from '../../shared/helpers/app.constants';
import { Subscription } from 'rxjs';
import { Helper } from '../../shared/helpers/helper';
import { ToasterService } from '../../shared/services/toaster.service';

@Component({
  selector: 'app-channel-mapping',
  templateUrl: './channel-mapping.component.html',
  styleUrls: ['./channel-mapping.component.scss']
})
export class ChannelMappingComponent implements OnInit, OnDestroy {

  @Input() dataSource = [];
  subscriptions: Subscription[] = [];

  formAdding: FormGroup;
  channelName: AbstractControl;

  pageState = {
    submitting: false,
    loading: false,
    isShowCompanySelector: false,
    currentCompanyId: undefined,
  };
  // Company List
  listCompanies: any[] = [];
  selectedListCompanies: any[] = [];
  listRealtimeChannels: any[] = [];

  pagingState = { ...pagingDefaultSettings };

  listMappedChannel: any[] = [];

  constructor(
    private nbDialogService: NbDialogService,
    private channelMappingService: ChannelMappingService,
    private channelMappingStorageService: ChannelMappingStorageService,
    private userService: UserService,
    private userRolesService: UserRolesService,
    private companiesService: CompaniesService,
    private fb: FormBuilder,
    private loadingOverlayService: LoadingOverlayService,
    private toasterService: ToasterService
  ) { }

  get dataTable(): any[] {
    const result = this.dataSource.slice(
      (this.pagingState.page - 1) * this.pagingState.pageSize,
      (this.pagingState.page - 1) * this.pagingState.pageSize + this.pagingState.pageSize
    );
    return result;
  }

  ngOnInit(): void {
    this.pageState.loading = true;
    this.createAddingForm();
    this.userService.getCurrentUser().subscribe((response) => {
      if (response && response.result) {
        const userDetail = response.result;
        const userRole = this.userRolesService.toUserRole(userDetail).toLowerCase();
        if (userDetail.companyId) {
          this.pageState.currentCompanyId = userDetail.companyId;
        } else {
          this.pageState.currentCompanyId = 0;
        }
        if (userRole && typeof userRole === 'string') {
          // if carbo admin the hide company selector
          if (userRole && this.userRolesService.isAdmin(userRole)) {
            if (this.userRolesService.isCarboAdmin(userRole)) {
              this.pageState.isShowCompanySelector = true;
              // Get list companies
              this.subscriptions.push(
                this.companiesService.getListCompany().subscribe(res => {
                  if (res && res.result && res.result.items) {
                    this.listCompanies = orderBy(res.result.items, item => item.name.toLowerCase());
                    const carboAdmin = [{id: 0, name: 'Carbo Company'}];
                    this.listCompanies = carboAdmin.concat(this.listCompanies);
                    this.selectedListCompanies = carboAdmin;
                  }
                })
              );
            }
          }
        }
        // load data by company
        this.loadDataTable(this.pageState.currentCompanyId);
        // this.getRealtimeChannels(this.pageState.currentCompanyId);
      }
    }, (error) => {
      this.pageState.loading = false;
    });
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  createAddingForm() {
    this.formAdding = this.fb.group({
      channelName: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(CPATTERN.CHANNEL_MAPPING_NAME)]
      ]
    });
    this.channelName = this.formAdding.controls['channelName'];
  }

  loadDataTable(companyId) {
    const currentCompanyId = companyId ? companyId : '';
    this.listMappedChannel = [];
    this.pageState.loading = true;
    this.subscriptions.push(
      this.channelMappingService.getAll(currentCompanyId).subscribe(res => {
        let data = [];
        if (res && res.result) {
          data = res.result.sort((a, b) => a > b);
          this.dataSource = data;
          this.channelMappingStorageService.setChannelMapped(currentCompanyId, data);
          forEach(data, item => {
            this.listMappedChannel = this.listMappedChannel.concat(item.mappedChannel);
          });
          this.pagingState.collectionSize = this.dataSource.length;
        }
        this.pageState.loading = false;
      }, err => {
        this.pageState.loading = false;
      })
  );
  }

  // Change company only available for Carbo Admin
  onChangeCompany(company) {
    if (this.pageState.currentCompanyId !== company.id) {
      if (company && company.id) {
        this.pageState.currentCompanyId = company.id;
      } else {
        this.pageState.currentCompanyId = 0;
      }
      this.loadDataTable(this.pageState.currentCompanyId);
      // this.getRealtimeChannels(this.pageState.currentCompanyId);
    }
  }

  onAddMapping(event?) {
    if (this.formAdding.valid && this.channelName.value.trim()) {
      this.pageState.submitting = true;
      const reqPayload = {
        channelMappedName: this.channelName.value,
        companyId: this.pageState.currentCompanyId ? this.pageState.currentCompanyId : ''
      };
      this.subscriptions.push(
        this.channelMappingService.create(reqPayload, () => {
          this.pageState.submitting = false;
        }).subscribe(res => {
          this.formAdding.reset();
          this.loadDataTable(this.pageState.currentCompanyId);
        })
      );
    }
  }

  showEdit(event, item) {
    this.nbDialogService.open(ChannelMappingEditComponent, {
      autoFocus: false,
      context: {
        selectedItem: {...item},
        currentCompanyId: this.pageState.currentCompanyId ? this.pageState.currentCompanyId : ''
      }
    })
      .onClose.subscribe(data => {
        if (data) {
          this.loadDataTable(this.pageState.currentCompanyId);
        }
    });
  }

  delete(event, item) {
    this.nbDialogService.open(ModalConfirmComponent, {
      context: {
        config: {
          title: 'Delete',
          message: `Are you sure you want to delete <br> <b class="h6">${item.name}</b>?`,
          className: 'pop-delete common-page',
          btnTxtConfirm: 'Yes',
          btnTxtCancel: 'No',
        }
      }
    })
      .onClose.subscribe(response => {
        if (response && response.confirm && item && item.name) {
          const currentCompanyId = this.pageState.currentCompanyId ? this.pageState.currentCompanyId : '';
          this.pageState.loading = true;
          this.subscriptions.push(
            this.channelMappingService.delete(item.name, currentCompanyId).subscribe(res => {
              this.loadDataTable(currentCompanyId);
            }, err => {
              this.pageState.loading = false;
            })
          );
        }
    });
  }

}
